<template>
    <div class="fullheight">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="container">
          <div class="navbar-brand">
            <a class="navbar-item" style="padding-top: 10px">
              <img
                src="../../src/assets/img/cardiff-white-text-only.png"
                id="logo"
                height="28"
              />
            </a>
          </div>
        </div>
      </nav>
      <div class="container is-fluid fullheight" id="appcontainer">
        <div class="columns fullheight is-centered">
          <div class="column" id="app-column-second-signer">
              <transition name="slide" mode="out-in">
                <LeadSecondSignerLoading
                v-if="page == 0"
                key="p0"
                @next="incrementPage"
                @doublenext="page += 2"
                :link="$route.params.sfLeadId"
              />
                <Breifing
                  v-if="page == 1"
                  key="p1"
                  @next="incrementPage"
                  :business="model.business.name"
                  :pgname="model.pg.name"
                />
                <PersonalInfo
                  v-if="page == 2"
                  key="p2"
                  @next="incrementPage"
                  :toggle_job_title="true"
                />
                <VerifyOwnership
                  v-if="page == 3"
                  key="p3"
                  @next="incrementPage"
                  :removeTid="true"
                />
                <!-- <Signature
                  v-if="pages[index].name == 'Signature'"
                  key="Signature"
                  @next="incrementPage"
                /> -->
                <Approval
                  v-if="page == 4"
                  key="p4"
                  title="Congrats!"
                  :texts="finishText"
                  @next="incrementPage"
                />
              </transition>
            </div>
          </div>
        </div>
      <footer
        class="footer mobile-only"
        style="margin-top: 60px"
      >
        <div class="content has-text-centered">
          <img
            src="../../src/assets/img/bbb.svg"
            style="margin-left: 15px; max-width: 120px"
          />
          <img
            src="../../src/assets/img/ssl.svg"
            style="margin-left: 15px; max-width: 120px; margin-right: 15px"
          />
          <p style="font-size: 0.675em; color: grey; margin-top: 10px">
            © 2024 Cardiff, Inc
          </p>
        </div>
      </footer>
    </div>
  </template>
  
  <script>
  import {
    LeadSecondSignerLoading,
    PersonalInfo,
    VerifyOwnership,
    // Signature,
    Approval,
    Breifing,
  } from "@/components/apply/pages";
  import { build } from "@/tools/modelBuilder";
  import $ from "jquery";

  function getWithExpiry(key) {
        const itemStr = localStorage.getItem(key);
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }

    function setWithExpiry(key, value, ttl) {
        const now = new Date();

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        };
        localStorage.setItem(key, JSON.stringify(item));
    }
    
  export default {
    name: "LeadSecondSigner",
    components: {
        LeadSecondSignerLoading,
        PersonalInfo,
        VerifyOwnership,
        //   Signature,
        Breifing,
        Approval,
    },
    data() {
      return {
        page: 0,
        demo: false,
        model: {
          sfleadid: null,
          business: { name: null },
          pg: { name: null },
        },
        finishText: [
          { str: "You've successfully completed the Additional Owner Information!" },
          {
            str: "You can now close this page. A representative will contact you if we need any additional information.",
          },
        ],
      };
    },
    computed: {},
    methods: {
      incrementPage: function (pageData) {
        console.log("pageData", pageData);
        this.model = build(this.model, pageData);
        // if (pageData.customerId) {
        //   console.log("we have the customer id ", pageData.customerId);
        //   this.customerId = pageData.customerId;
        // }
        var self = this;
        if(self.page > 1){
            
            console.log('this page', self.page);
            $.ajax({
            type: "POST",
            url: "/api/lead_second_signer/post",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
                model: self.model,
                page: self.page,
            }),
            })
          .done(function (response) {})
          .fail(function (err) {
            console.log(err.responseText);
            self.invalid = true;
          });
        }
        self.page++;
        console.log('this page', self.page);
        window.scrollTo(0, 0);
      },
    },
    mounted: function () {
      // send api call to get pages
      console.log(this.$route.params.code);
      var self = this;
    },
    created : function(){
      // console.log("created renewal apply");
      // console.log('created renewal apply')
      let self = this;

      self.model.medium = "";
        self.model.source = "";
        self.model.campaign = "";

        let url_query = "";
        if (self.$route.query && self.$route.query != "") {
        url_query = self.$route.query;
        }
        console.log("url query:" + url_query);

        if (
        url_query &&
        url_query.utm_campaign &&
        url_query.utm_campaign.length !== 0
        ) {
            self.model.campaign = url_query.utm_campaign;
        }
        if (
        url_query &&
        url_query.utm_medium &&
        url_query.utm_medium.length !== 0
        ) {
            self.model.medium = url_query.utm_medium;
        }
        if (
        url_query &&
        url_query.utm_source &&
        url_query.utm_source.length !== 0
        ) {
            self.model.source = url_query.utm_source;
        }


      if (
        self.$route.params &&
        self.$route.params.sfLeadId
      ) {
        let lead_id = self.$route.params.sfLeadId;
        setWithExpiry("sfLeadId", lead_id, 259200);
        setTimeout(function(){
          console.log('verifying link!');
        $.ajax({
            type: "POST",
            url: "/api/lead_second_signer/load",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({ sf_leadid: lead_id, model: self.model }),
          })
            .done(function (response) {
            console.log("verify link response");
            console.log(response);
            if (response.valid && response.valid == true) {
                setWithExpiry("first_name", response.first_name, 259200);
                self.model.business.name = response.business_name;
                self.model.pg.name = response.first_name;
                self.model.sfleadid = self.$route.params.code;
            } else {
                setWithExpiry("first_name", null, 1);
                // self.next();
                // self.invalid = true;
            }
              self.incrementPage({})
            })
            .fail(function (err) {
              console.log("fail");
              console.log(err.responseText);
              // self.invalid = true;
            });
      },1000);
      }
  
      const sfLeadId = getWithExpiry("sfLeadId");
      console.log('sfLeadId from memory:', sfLeadId);
      if (sfLeadId) {
        self.model.sfLeadId = sfLeadId;
      }
    },
  };
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .navbar {
    background-color: #3c5cac;
    z-index: 2;
  }
  .navbar .navbar-brand {
    text-align: center;
    display: block;
    width: 100%;
  }
  
  .navbar .navbar-brand > .navbar-item,
  .navbar .navbar-brand .navbar-link {
    display: inline-block;
  }
  #app-column-second-signer{
    max-width: 830px;
  }
  @media screen and (min-width: 767px), print {
    .mobile-only {
      display: none;
    }
    #appcontainer {
      margin-left: 0px;
      margin-right: 0px;
    }
    .fullheight {
      height: 100%;
      /* height: 100vh; */
    }
    #app-column-second-signer {
      padding: 20px 100px;
      width: 100%;
    }
  }
  
  @media screen and (max-width: 768px) {
    #cardiff-column {
      display: none;
    }
    #app-column-second-signer {
      min-height: 100vh;
    }
    .fixed-tabs {
      position: fixed;
      z-index: 2;
      background: white;
      top: 0px;
      width: 100%;
      left: 0px;
      transition: all 0.3s;
    }
    .pushed-pages {
      margin-top: 55px !important;
    }
  }
  
  #cardiff-column {
    /* background: #f1f1f1; */
    background: linear-gradient(
      90deg,
      rgb(246, 246, 246) 0%,
      rgb(242, 242, 242) 57%,
      rgb(237, 237, 237) 100%
    );
    z-index: 1;
    padding-top: 50px;
    max-width: 280px;
  }
  
  #logo {
    /* max-width: 50%; */
    margin: auto;
    display: block;
    /* margin-top: 10px; */
    /* margin-bottom: 10px; */
  }
  
  .next-button {
    margin-top: 10px;
  }
  
  .columns {
    margin-left: 0;
    margin-right: 0;
  }
  
  .no-margin {
    margin-bottom: 0px !important;
  }
  </style>
  